import config from 'appConfig';
import { redirect } from 'Utils/redirector';

export function authenticateWithGoToOpener(redirectUri) {
  const url = `${config.oauth.url}/oauth/authorize?response_type=code&client_id=${config.oauth.goToOpenerClientId}&redirect_uri=${redirectUri}`;
  redirect(url);
}
